.EventLayout {
  display: grid;
  grid-template-columns: minmax(12rem, 15rem) minmax(0, 1fr);
  gap: 1.25rem;
  align-items: start;
  margin-top: 1rem;
}

.FiltersPanel {
  position: sticky;
  top: 1rem;
}

.EventMain {
  min-width: 0;
}

@media (max-width: 991.98px) {
  .EventLayout {
    grid-template-columns: 1fr;
  }

  .FiltersPanel {
    position: static;
  }
}
